<template>
  <div id="simple-calendar-app" class="">
    <div class="vx-card pr-2 pb-1" style="min-height: 90vh;" >
      <div class="vx-row " style="height: 100%; ">

        <div class="vx-col w-full sm:w-full md:w-1/5 lg:w-1/5 xl:w-1/5 pl-2">
          

          <div class="vx-row mt-2 ml-2 pt-3">
            <!-- Add new event button -->
            <vs-button class="ml-4" icon-pack="feather" icon="icon-plus" @click="handleEventAdd(new Date())">Agregar</vs-button>
          </div>
          <div class="vx-row mt-2 ml-2">
              <calendar
                is-expanded
                title-position="left"
                locale="es"
                class="mt-6"
                
                :attributes="miniCalendar"
              ></calendar>
          </div>
          <div class="vx-row mt-6 ml-1">
            
            <div class="vx-col w-full">
              <h4 class="mt-3 inline">Clínicas</h4>
              <vs-button class="inline ml-3" color="primary" icon-pack="feather" icon="icon-plus" @click="$modal.show('newClinicModal');"></vs-button>
            </div>

          </div>
          <div class="vx-row mt-1 ml-2">  
             <ul class="centerx ml-3 mt-4">
                <li v-for="(clinic, index) in calendarClinics" class="mb-2" :key="index">
                  <vs-checkbox color="success" v-model="clinicsActive[clinic.id]"> {{clinic.title}} </vs-checkbox>
                </li>
              </ul>
          </div>
          <div class="vx-row mt-6 ml-1">
            
            <div class="vx-col w-full">
              <h4 class="mt-3 inline">Calendarios</h4>
            </div>

          </div>
          <div class="vx-row mt-1 ml-2">
              
             <ul class="centerx ml-3 mt-4">
                <li class="mb-2 flex">
                  <vs-checkbox  class="flex inline" color="#0034A1" v-model="typesActive" vs-value="consultation">Consultas</vs-checkbox>
                </li>
                <!-- <li class="mb-2 flex">
                  <vs-checkbox  class="flex inline" color="success" v-model="typesActive" vs-value="virtual_consultation">Consultas Virtuales</vs-checkbox>
                    <feather-icon icon="BriefcaseIcon" style="color: #0034A1"/>
                </li> -->
                <li class="mb-2 flex">
                  <vs-checkbox color="#021d49" class="flex inline" v-model="typesActive" vs-value="meeting">Eventos</vs-checkbox>
                </li>
                <li class="mb-2 flex">
                  <vs-checkbox color="#00a7e1" class="flex inline" v-model="typesActive" vs-value="appointment">Recordatorios</vs-checkbox>                  
                </li>
              </ul>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-4/5 lg:w-4/5 xl:w-4/5 pt-4 pl-3" style="height: 90vh; overflow-y: scroll;">
            <full-calendar ref="fullCalendar" :options="calendarOptions" />          
        </div>
      </div>

    </div>

    <modal
      name="newEventModal"
      height="92%"
      width="60%"
      :scrollable='true'
      classes="overflow"
    >
      <form data-vv-scope="new-event">
        <div class="p-3">
          <div v-if="!edittingEvent" class="vw-row w-full pl-2 pt-2">
            <h2>Nuevo Evento</h2>
          </div>
          <div v-else class="vw-row w-full pl-2 pt-2">
            <h2>Editar Evento #{{edittingId}} </h2>
          </div>
          <div class="vx-row w-full" v-if="!edittingEvent">
            <div class="vx-col w-full">
              <h5 class="ml-3 mt-4">Tipo de Evento</h5>
            </div>
            <div class="vx-col w-full mt-3 ml-3" >
              
              <div @click="eventData.eventType = 'consulta'">
                <vs-chip class="py-1 mr-4" :color="eventData.eventType == 'consulta' ? '#0034A1' : '#a0a4a5'">
                  <vs-icon class="mr-3" icon="assignment_ind"/>
                  <p style="font-size:14px">Consulta</p>
                </vs-chip>
              </div>
              <div @click="eventData.eventType = 'evento'">
                <vs-chip class="py-1 mr-4" :color="eventData.eventType == 'evento' ? '#0034A1' : '#a0a4a5'">
                  <vs-icon class="mr-3" icon="event"/>
                  <p style="font-size:14px">Evento</p>
                </vs-chip>
              </div>
              <div @click="eventData.eventType = 'recordatorio'">
                <vs-chip class="py-1 mr-4" :color="eventData.eventType == 'recordatorio' ? '#0034A1' : '#a0a4a5'">
                  <vs-icon class="mr-3" icon="notifications"/>
                  <p style="font-size:14px">Recordatorio</p>
                </vs-chip>
              </div>

            </div>
          </div>

        <vs-divider icon-pack="feather" class="mt-2" icon="icon-chevron-down" position="center" color="primary"></vs-divider>
        <div v-if="eventData.eventType">
          <div>     
            <div class="vx-row w-full mt-3" v-if="eventData.eventType == 'consulta'">
              <div class="vx-col w-1/3">
                <p class="ml-3">Clínica<p/>
              </div>
              <div class="vx-col w-2/3 flex">
                <v-select class="inline w-full mr-2" :options="docClinics" label="title" 
                  v-validate="'required'"  name="clinica" 
                  :reduce="option => option.id"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                >
                  <template v-slot:option="option">
                    <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                      'https://img.icons8.com/ios/24/000000/zoom.png' :
                      'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                    <p class="inline"
                      :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                        ? 'text-danger' : 'text-primary'"
                    >{{ 
                      (option.meta.type.toLowerCase() == 'virtual')
                       && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                      ?  `${option.title} - Sin Activar` : option.title
                    }}</p>
                  </template>
                </v-select> 
                <div v-if="!eventData.clinic_id">
                  <vs-button class="inline" color="primary" type="gradient" icon="local_hospital" @click="$modal.show('newClinicModal');"></vs-button>
                </div>
              </div>
            </div>
            <div class="vx-row w-full" v-if="(eventData.eventType  == 'consulta')">
              <div class="vx-col w-1/3">
              </div>
              <div class="vx-col w-2/3 flex">
                <span class="text-danger">{{ errors.first('new-event.clinica') }}</span>
              </div>
            </div>
            <div class="vx-row w-full mt-1 mb-4" v-if="eventData.eventType == 'consulta' && !(findZoomClinicsActive.length>0)">
              <p class="ml-3 w-full text-center"  style="font-size: 13px; color:#00a7e1 ">
                *Para activar tu clinica virtual de Zoom debes ir a:
                <span @click="goSettings" class="ml-2" style="font-weight: 600">
                  <feather-icon
                    icon='SettingsIcon'
                    svgClasses="w-4 h-4 m-1"
                    class="" />
                  Ajustes/Conexiones
                </span>
              </p>
            </div>
            <div class="vx-row w-full mt-3" v-if="(eventData.eventType == 'consulta')">
              <div class="vx-col w-1/3">
                <p class="ml-3">Paciente<p/>
              </div>
              <div class="vx-col w-2/3 flex">
                <v-select class="inline w-full mr-2" :options="patientsList" label="first_name" :filter-by="patientFilter" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-validate="'required'" name="paciente" :reduce="option => option.id" v-model="eventData.patient_id" >
                    <template v-slot:option="option">
                      {{ option.first_name }} {{option.last_name}} ({{option.email}})
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        {{ option.first_name }} {{option.last_name}} ({{option.email}})
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se encontraron pacientes para: <em>{{ search }}</em>.
                      </template>
                      <em style="opacity: 0.5;" v-else>Escribir para buscar pacientes.</em>
                    </template>
                </v-select>
                <div v-if="!eventData.patient_id">
                  <vs-button class="inline" color="primary" type="gradient" icon-pack="feather" icon="icon-user-plus" @click="$modal.show('newPatientModal');"></vs-button>
                </div>
              </div>
            </div>
            <div class="vx-row w-full" v-if="(eventData.eventType == 'consulta')">
              <div class="vx-col w-1/3">
              </div>
              <div class="vx-col w-2/3 flex">
                <span class="text-danger w-full">{{ errors.first('new-event.paciente') }}</span>
              </div>
            </div>
          </div>        
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="ml-3">Fecha<p/>
            </div>
            <div class="vx-col w-2/3">
              <flat-pickr class="w-full" :config="configdateTimePicker" v-model="eventData.date" placeholder="Fecha"
                v-validate="'required'" name="fecha" />
              <span class="text-danger w-full">{{ errors.first('new-event.fecha') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType =='consulta' || edittingEvent">
            <div class="vx-col w-1/3">
              <p class="ml-3">Hora<p/>
            </div>
            <div class="vx-col w-2/3" >
              <v-select v-if="eventData.date && eventData.clinic_id" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.hour" 
                :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                :selectable="option => option.available"
              >
              <template slot="selected-option" slot-scope="option">
                  {{ `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}` }}
              </template>
                <template v-slot:option="option">
                  <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                    `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}`
                  }}</p>
                  <small v-if="!option.available" class="ml-2 text-danger">
                    No Disponible
                  </small>
                </template>
              </v-select>
              <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
              <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
            </div>
          </div>
          <!-- EVENTO-->
          <div class="vx-row w-full mt-3" v-if="eventData.eventType =='evento' || eventData.eventType == 'meeting'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Hora de inicio<p/>
            </div>
            <div class="vx-col w-2/3" >
              <v-select v-if="eventData.date" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.hour" 
                :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                :selectable="option => option.available"
              >
              <template slot="selected-option" slot-scope="option">
                  {{ `${convertUTC_TIME(option.date1)}` }}
              </template>
                <template v-slot:option="option">
                  <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                    `${convertUTC_TIME(option.date1)}`
                  }}</p>
                  <small v-if="!option.available" class="ml-2 text-danger">
                    No Disponible
                  </small>
                </template>
              </v-select>
              <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
              <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType =='evento' || eventData.eventType == 'meeting'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Hora de fin<p/>
            </div>
            <div class="vx-col w-2/3" >
              <v-select v-if="eventData.date && eventData.hour" :options="clinicAvailabilityByDateEnd" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.end" 
                :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                :selectable="option => option.available"
              >
              <template slot="selected-option" slot-scope="option">
                  {{ `${convertUTC_TIME(option.date1)}` }}
              </template>
                <template v-slot:option="option">
                  <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                    `${convertUTC_TIME(option.date1)}`
                  }}</p>
                  <small v-if="!option.available" class="ml-2 text-danger">
                    No Disponible
                  </small>
                </template>
              </v-select>
              <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
              <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType =='consulta'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Duración<p/>
            </div>
            <div class="vx-col w-2/3">
              <p class="ml-6">
                <strong>{{eventData.duration}} minutos</strong>
              </p>
              <vs-input-number style="display:none" color="primary" v-model="eventData.duration" :step="5" disabled readonly label="Minutos:" :min="10"  :max="180"
                v-validate="'required|max_value:180|min_value:10'" name="duracion" />
              <span class="text-danger w-full">{{ errors.first('new-event.duracion') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType =='eventoss'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Duración<p/>
            </div>
            <div class="vx-col w-2/3">
              <p class="ml-6">
              <!--<strong>{{eventData.duration}} minutos</strong> -->
              </p>
              <vs-input-number color="primary" v-model="duration" :step="10" label="Minutos:" :min="10"  :max="360"
                v-validate="'required|max_value:360|min_value:10'" name="duracion" />
              <span class="text-danger w-full">{{ errors.first('new-event.duracion') }}</span>
            </div>
          </div>
          <!-- <div v-if="eventData.timeType == 'normal' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-full">
                <p class="ml-5">Horas Disponibles<p/>
              </div>
              <div class="vx-col w-full text-center my-2">
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '10:20'">10:20</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '11:30'">11:30</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '13:00'">13:00</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '15:30'">15:30</vs-button>
              </div>
            </div>
          </div> -->
          <div v-if="eventData.timeType == 'advanced' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-1/2 flex">
                <p class="my-1 ml-3 text-center inline">Inicio</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time1" placeholder="Inicio" class="w-full inline ml-3"/>
              </div>
              <div class="vx-col w-1/2 flex">
                <p class="my-1 text-center inline">Fin</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time2" placeholder="Fin" class="w-full inline ml-3" />
              </div>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Titulo</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-input name="titulo" v-validate="'required'" class="w-full"  v-model="eventData.title"></vs-input>
               <span class="text-danger w-full">{{ errors.first('new-event.titulo') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Notas</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-textarea name="notas" v-validate="''" v-model="eventData.notes" height="50px" />
               <span class="text-danger w-full">{{ errors.first('new-event.notas') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="false">
            <div class="vx-col w-full flex flex-col items-center">
              <vs-checkbox color="success" v-model="eventData.notification">Notificar</vs-checkbox>
            </div>
          </div>
           <vs-divider class="my-6" />
          <div class="vx-row w-full mt-6">
            <div class="vx-col flex flex-col items-center w-full">
              <div v-if="!edittingEvent" class="">
              <vs-button class="px-5" color="primary" type="filled" @click="validateAddNewEvent('add')">Agregar</vs-button>
              </div>
              <div v-else class="items-center flex">
                <vs-button class="px-5 inline" color="success" type="filled" @click="validateAddNewEvent('edit')">Guardar</vs-button>
                <vs-button class="px-5 ml-5" color="danger" type="filled" @click="cancelEditEvent()">Cancelar</vs-button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </form>
      
      <modal
            name="newPatientModal"
            height="auto"
            width="60%"
            :scrollable="true"
            style="z-index: 1005;"
          >
            <form data-vv-scope="new-patient">

            
              <div class="vx-row my-3 ml-1">
                <div class="vx-col w-full" >
                <h2>Nuevo Paciente</h2>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                  <vs-input class="w-full px-5" label="Nombre(s)*" placeholder="Nombre(s)"
                  name="nombres" v-validate="'required'" v-model="newPatient.first_name"/>
                  <span class="text-danger">{{ errors.first('new-patient.nombres') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Apellidos(s)*" placeholder="Apellidos(s)"
                  name="apellidos" v-validate="'required'" v-model="newPatient.last_name" />
                  <span class="text-danger">{{ errors.first('new-patient.apellidos') }}</span>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Celular*" placeholder="Celular"
                  name="celular" v-validate="'required|digits:8'" v-model="newPatient.phone[0]"/>
                  <span class="text-danger">{{ errors.first('new-patient.celular') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Número de teléfono" placeholder="Número de teléfono" 
                  name="telefono" v-validate="''" v-model="newPatient.phone[1]"/>
                  <span class="text-danger">{{ errors.first('new-patient.telefono') }}</span>
                </div>
              </div>
              <div class="vx-row mt-4 mb-5">
                <div class="vx-col  w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Correo Electrónico*" placeholder="Correo Electrónico"
                  name="email" v-validate="''" v-model="newPatient.email"/>
                  <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
                </div>
              </div>
              <div class="vx-row mt-4 mb-5" v-if="false">
                <div class="vx-col  w-full flex flex-col items-center">
                  <p>¿Desea enviar formulario de registro?</p>
                   <ul class="mt-2">
                      <li class="ml-3">
                        <vs-radio v-model="notifyPatient" name="notificar" v-validate="'required'" :vs-value="true">
                          Si
                        </vs-radio>
                      </li>
                      <li class="ml-3">
                        <vs-radio v-model="notifyPatient" name="notificar" v-validate="'required'" :vs-value="false">
                          No
                        </vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger ml-5">{{ errors.first('new-patient.notificar') }}</span>
                </div>
              </div>
              <div v-if="registerPatient">
                <div class="vx-row mt-4 mb-4">
                  <div class="vx-col w-full md:w-1/3 flex flex-col inline">
                      <p class="inline px-5 mb-3" style="font-size: 13px;">Sexo*</p>
                      <ul class="ml-6">
                        <li class="ml-3">
                          <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="male">
                            Másculino
                          </vs-radio>
                        </li>
                        <li class="ml-3">
                          <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="female">
                            Femenino
                          </vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger ml-5">{{ errors.first('new-patient.sexo') }}</span>
                  </div>
                  <div class="vx-col w-full md:w-2/3 flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Fecha de Nacimiento*</p>
                      <datepicker class="px-5" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                        name="fecha_de_nacimiento" v-validate="'required'" v-model="newPatient.dob"></datepicker>
                      <span class="ml-5 text-danger">{{ errors.first('new-patient.fecha_de_nacimiento') }}</span>
                  </div>
                </div>
                <div class="vx-row mt-4 mb-2">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Identificación*</p>
                      <div class="vx-row">
                          <div class="vx-col w-1/3">
                              <v-select class="pl-5" placeholder="Documento" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="tipo" v-validate="'required'" v-model="newPatient.idtype" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.tipo') }}</span>
                          </div>
                          <div class="vx-col w-2/3 ">
                              <vs-input class="px-5 inputx w-full"  placeholder="Número de identificación"
                                name="identificacion" v-validate="'required'" v-model="newPatient.idNum" />
                              <span class="ml-5 text-danger">{{ errors.first('new-patient.identificacion') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="vx-row mb-1">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-1/2">
                              <p class="pl-5" style="font-size: 13px;">País</p>
                              <v-select class="pl-5" placeholder="País" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="pais" label="name" v-validate="''" v-model="newPatient.country" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.pais') }}</span>
                          </div>
                          <div class="vx-col w-1/2 ">
                            <p class="" style="font-size: 13px;">Ciudad</p>
                            <v-select 
                              :disabled="newPatient.country ? false : true" :options="newPatient.country ? getStatesP : []"
                              class="pr-5" placeholder="Ciudad" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="ciudad" v-validate="''" v-model="newPatient.city" />
                            <span class="ml-5 text-danger">{{ errors.first('new-patient.ciudad') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-1/2">
                              <vs-input class="pl-5 inputx w-full" label="Dirección" placeholder="Dirección"
                                name="direccion" v-validate="''" v-model="newPatient.address" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.direccion') }}</span>
                          </div>
                          <div class="vx-col w-1/2 ">
                              <vs-input class="pr-5 inputx w-full" label="Complemento" placeholder="Complemento dirección"
                                name="direccion_2" v-validate="''" v-model="newPatient.address_2" />
                              <span class="ml-5 text-danger">{{ errors.first('new-patient.direccion_2') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                
              </div>
              
              <vs-divider class="mt-6 mb-5" />

              <div class="vx-row pt-3 pb-6">
                <div class="vx-col w-full flex justify-center">
                  <vs-button class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-mail"
                    v-if="!registerPatient" @click="validateNewPatient">
                    Agregar
                  </vs-button>
                  <!-- <vs-button class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-mail"
                    v-if="!registerPatient" @click="validateNewPatient">
                    Nuevo
                  </vs-button>
                  <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="!registerPatient" @click="registerPatient = !registerPatient">
                    Registrar Datos
                  </vs-button> -->
                  <vs-button color="danger" class="mr-4" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="registerPatient" @click="registerPatient = !registerPatient">
                    Cancelar
                  </vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-save" 
                    v-if="registerPatient" @click="validateNewPatient">
                    Registrar Usuario
                  </vs-button>
                </div>
              </div>
            </form>
      </modal>
    </modal>

    

    <modal
      name="newClinicModal"
      height="auto"
      width="60%"
      :draggable="true"
      :resizable="true"
    >
      <div class="p-3">
        <form data-vv-scope="new-clinic">
          <div class="vx-row w-full mt-2 pl-4 pb-1"><h3>Nueva Clínica</h3></div>
          <div class="vx-col w-full">
            <p class="my-1 ml-3">Titulo*</p>
          </div>
          <div class="vx-col w-full">
            <vs-input name="titulo"  class="w-full"  v-model="newClinic.title" v-validate="'required'"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.titulo') }}</span>
          </div>

          <div class="vx-col w-full">
            <p class="mt-3 mb-1 ml-3">Teléfono*</p>
          </div>
          <div class="vx-col w-full">
            <vs-input name="telefono"  class="w-full"  v-model="newClinic.phone" v-validate="'required|digits:8'"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.telefono') }}</span>
          </div>
          
          <div class="vx-col w-full" v-if="newClinic.type !== 'Virtual'">
            <p class="mt-3 mb-1 ml-3">Dirección*</p>
          </div>
          <div class="vx-col w-full" v-if="newClinic.type !== 'Virtual'">
            <vs-input name="direccion" v-validate="'required'" class="w-full"  v-model="newClinic.address"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.direccion') }}</span>
          </div>
          <div class="vx-row" v-if="newClinic.type !== 'Virtual'">
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <p class="mt-3 mb-1 ml-3">Dirección Complementaria</p>
                </div>
                <div class="vx-col w-full">
                  <vs-input name="complemento" v-validate="''" class="w-full"  v-model="newClinic.address2"></vs-input>
                  <span class="text-danger">{{ errors.first('new-clinic.complemento') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                <p class="mt-3 mb-1 ml-3">Zona*</p>
              </div>
              <div class="vx-col w-full">
                <vs-input name="zona" v-validate="'digits:2|required'" class="w-full"  v-model="newClinic.zone"></vs-input>
                <span class="text-danger">{{ errors.first('new-clinic.zona') }}</span>
              </div>
              </div>
            </div>
          </div>
          
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <p class="mt-3 ml-3">País*</p>
                </div>
                <div class="vx-col w-full">
                  <v-select :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    name="pais" label="name" v-validate="'required'" class="w-full"  v-model="newClinic.country" />
                  <span class="text-danger">{{ errors.first('new-clinic.pais') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                <p class="mt-3 mb-1 ml-3">Ciudad*</p>
              </div>
              <div class="vx-col w-full">
                <v-select :disabled="newClinic.country ? false : true" :options="newClinic.country ? getStates : []" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                  name="ciudad" v-validate="'required'" class="w-full"  v-model="newClinic.city" />
                <span class="text-danger">{{ errors.first('new-clinic.ciudad') }}</span>
              </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full mt-4">
            <p class="my-1 ml-3">Notas Adicionales</p>
          </div>
          <div class="vx-col w-full">
            <vs-textarea name="notas" v-validate="''" class="w-full"  v-model="newClinic.notes" />
          </div>
          <div class="vx-col w-full">
            <p class="mt-6 ml-3"  style="font-size: 13px; color:#00a7e1 ">
              *Para activar tu clinica virtual de Zoom debes ir a:
              <span @click="goSettings" class="ml-2" style="font-weight: 600">
                <feather-icon
                  icon='SettingsIcon'
                  svgClasses="w-5 h-5 m-1"
                  class="" />
                Ajustes/Conexiones
              </span>
            </p>
          </div>
          <vs-divider style="margin-top: 20px;"></vs-divider>
          <div class="vx-col w-full flex flex-col items-center mt-2">
            <vs-button class="px-5" color="primary" type="filled" @click="validateNewClinic">Agregar</vs-button>
          </div>
        </form>
      </div>
    </modal>
    <modal
    name="viewEventModal"
    height="auto"
    width="670"
    :draggable="false"
    >
      <div class="my-2 mr-3 mb-5 mx-1">
        <vs-row vs-type="flex" class="mb-2 mt-4" vs-justify="flex-end">
          <vs-col vs-justify="flex-start" vs-align="end" vs-w="4" class="pl-3">
            <h4 v-if="currEvent.extendedProps"  vs-align="center">Evento
              <a :href="`/consultations/newConsultation/?consultationId=${currEvent.id}`"> #{{currEvent.id}}</a>
            </h4>
          </vs-col>
          <vs-col class="" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="8">
                <vs-button 
                  v-if="
                    currEvent.extendedProps && 
                    (currEvent.extendedProps.type == 'consultation'  || currEvent.extendedProps.type == 'virtual_consultation') && !isSecretary"
                    color="primary" size="small" class="mr-4"
                  :to="viewUrl(currEvent.id)" @click.stop.prevent
                >Iniciar Consulta</vs-button>
                <vs-button size="default" radius class="mr-2" color="warning" type="filled" icon="edit"
                 @click="editEvent(currEvent)"
                ></vs-button>
                <vs-button radius size="default" class="mr-2" color="danger" type="filled" icon="delete"
                  @click="deleteEvent(currEvent.id)"
                ></vs-button>
                <div v-if="currEvent.extendedProps && currEvent.extendedProps.patient">
                  <vs-button 
                    radius size="default" color="primary" type="filled" class="mr-6" icon="email"
                    @click="emailEvent(currEvent.extendedProps.patient.email)"
                  ></vs-button>
                </div>
                <vs-button radius size="medium" color="primary" type="border" icon="close"
                  @click="hideEvent"
                ></vs-button>
          </vs-col>
        </vs-row>
        <vs-row v-if="currEvent.extendedProps">
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2">
            <vs-avatar 
            :color="
              currEvent.extendedProps.type == 'consultation'  ? '#0034A1'         :
              currEvent.extendedProps.type == 'virtual_consultation' ? '#34C873'  :
              currEvent.extendedProps.type == 'meeting' ? '#021d49'  :
              currEvent.extendedProps.type == 'appointment' ? '#00a7e1'  : 'gray'
            "
            :text="
              currEvent.extendedProps.type == 'consultation'  ? 'C'         :
              currEvent.extendedProps.type == 'virtual_consultation' ? 'CV'  :
              currEvent.extendedProps.type == 'meeting' ? 'E'  :
              currEvent.extendedProps.type == 'appointment' ? 'R'  : '.'
            "
            />
          </vs-col>
          <vs-col vs-type="" vs-justify="start" vs-align="start" vs-w="10">
              <h4 class="mt-2">{{currEvent.title}}</h4>
              <p class="inline" v-if="currEvent.startStr">
                {{new Date(currEvent.startStr).toLocaleDateString('es-ES', dateStringOptions)}}
            </p>
            <strong class="inline" v-if="currEvent.startStr">
                ・
                {{new Date(currEvent.startStr).toLocaleTimeString('en-EN', timeStringOptions)}}
            </strong>
            <strong class="inline" v-if="currEvent.endStr">
                - {{new Date(currEvent.endStr).toLocaleTimeString('en-EN', timeStringOptions)}}
            </strong>
          </vs-col>
        </vs-row>
        <vs-row v-if="currEvent.extendedProps && currEvent.extendedProps.clinic" class="my-2">
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2">
             <vs-avatar
              v-if="currEvent.extendedProps && 
                    (currEvent.extendedProps.type == 'consultation'  || currEvent.extendedProps.type == 'virtual_consultation')
                  " 
            :color="
              currEvent.extendedProps.type == 'consultation'  ? '#0034A1'         :
              currEvent.extendedProps.type == 'virtual_consultation' ? '#34C873'  : null
            "
            :icon="
              currEvent.extendedProps.type == 'consultation'  ? 'local_hospital'         :
              currEvent.extendedProps.type == 'virtual_consultation' ? 'videocam'  : null
            "
            />
          </vs-col>
          <vs-col v-if="currEvent.extendedProps.type !== 'meeting'" vs-type="" vs-justify="start" vs-align="start" vs-w="5">
              <h6 class="mt-2"><strong>Clínica:</strong>  {{currEvent.extendedProps.clinic.title}}</h6>
              <div v-if="currEvent.extendedProps.type !== 'virtual_consultation'">
                <p>
                  {{currEvent.extendedProps.clinic.address ? currEvent.extendedProps.clinic.address+' ' : ''}}
                  {{currEvent.extendedProps.clinic.country ? currEvent.extendedProps.clinic.country+' ' : ''}}
                </p>
                <p>
                  {{currEvent.extendedProps.clinic.address_2 ? currEvent.extendedProps.clinic.address_2 : ''}}
                </p>
                <p v-if="currEvent.extendedProps.clinic.notes">
                  <strong>Notas:</strong> {{currEvent.extendedProps.clinic.notes}}
                </p>
              </div>
              <div class="mt-4 ml-4" v-else>
                  <img src="@/assets/images/logo/zoomLogo.png" alt="Zoom" class="" style="width: 120px;">
              </div>
          </vs-col>
          <vs-col vs-type="" class="mb-3 mt-2" vs-justify="center" vs-align="center" vs-w="5" v-if="currEvent.extendedProps.type == 'virtual_consultation'">
              <!-- <vs-input disabled class="inputx w-3/5" placeholder="Disabled" id="meeting_url_input" v-model="currEvent.extendedProps.meeting_url_base"/>
              <vs-button class="ml-2" color="primary" type="filled" icon="content_copy"
                v-clipboard:copy="currEvent.extendedProps.meeting_url_base"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></vs-button>
              <vs-input disabled class="inputx w-1/5 ml-5" placeholder="Disabled" id="meeting_url_input" v-model="currEvent.extendedProps.meeting_password"/>
              <vs-button class="ml-2 mr-4" color="primary" type="filled" icon="content_copy"
                v-clipboard:copy="currEvent.extendedProps.meeting_password"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></vs-button> -->
              <vs-button color="primary" size="small" type="filled" icon="add_link" 
                v-clipboard:copy="'Link de Acceso: '+currEvent.extendedProps.meeting_url_base+' Contraseña: '+currEvent.extendedProps.meeting_password"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                Compartir Acceso y Contraseña</vs-button>
                <vs-button color="#2E88F7"  size="small" class="mt-3" type="filled" icon-pack="fa" icon="fa-video" @click="goLink(currEvent.extendedProps.meeting_url);">
                  Acceder como Administrador</vs-button>
          </vs-col>
          <!-- <vs-col vs-type="flex" class="mt-3" vs-justify="center" vs-align="start" vs-w="12" v-if="currEvent.extendedProps.type == 'virtual_consultation'">
              <h6>Acceso Administrativo: </h6>
          </vs-col> -->
          <vs-col vs-type="flex" class="mt-2 mb-4" vs-justify="center" vs-align="start" vs-w="12" v-if="currEvent.extendedProps.type == 'virtual_consultation'">
              <!-- <vs-input disabled class="inputx w-full" placeholder="Disabled" id="meeting_url_input" v-model="currEvent.extendedProps.meeting_url"/>
              <vs-button class="ml-3" color="primary" type="filled" icon="content_copy"
                v-clipboard:copy="currEvent.extendedProps.meeting_url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></vs-button> -->
          </vs-col>
        </vs-row>
        <vs-row class="mt-2" v-if="currEvent.extendedProps && currEvent.extendedProps.notes">
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2">
            <vs-button radius size="large" color="primary" type="flat" icon="comment">
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="" vs-align="center" vs-w="10">
              <p class=""> {{currEvent.extendedProps.notes}} </p>
          </vs-col>
        </vs-row>
        <vs-row class="mt-3" v-if="currEvent.extendedProps && currEvent.extendedProps.patient_id && currEvent.extendedProps.type !== 'meeting'">
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2">
            <vs-button radius size="large" color="primary" type="flat" icon="people_alt">
            </vs-button>
          </vs-col>
          <vs-col vs-type="" vs-justify="" vs-align="center" vs-w="5">
            <p class=""> {{currEvent.extendedProps.patient.first_name}} {{currEvent.extendedProps.patient.last_name}} </p>
            <a href="">
              <p class="" v-if="currEvent.extendedProps.patient.email">
                {{currEvent.extendedProps.patient.email}}
              </p>
            </a>
          </vs-col>
          <vs-col vs-type="" vs-justify="" vs-align="center" vs-w="4">
            <vs-button size="small" color="#00a7e1"  type="filled" icon="assignment_ind"
              @click="openPatientRecord(currEvent.extendedProps.patient_id)"
            >
              Ver Ficha
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row  class="mt-2" v-if="currEvent.extendedProps">
          <vs-col v-if="currEvent.extendedProps.type !== 'meeting'" vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2">
            <vs-button radius size="large" color="primary" type="flat" icon="notifications">
            </vs-button>
          </vs-col>
          <vs-col v-if="currEvent.extendedProps.type !== 'meeting'" vs-type="flex" vs-justify="" vs-align="center" vs-w="10">
            <p :class="currEvent.extendedProps.notification ? 'text-success' : 'text-danger'">
              {{currEvent.extendedProps.notification ? 'Notificaciones Activadas' : 'Notificaciones Desactivadas'}}
            </p>
          </vs-col>
        </vs-row>

        
        <div v-if="currEvent.virtual" class="vx-row mt-2 mb-4 ml-2">
              <div class="vx-col w-full mt-3">
                <vs-button class="w-1/2 ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-copy">Zoom Meeting</vs-button>
              </div>
        </div>
        <div v-if="currEvent.alert" class="vx-row mt-3 ml-2">
              <div class="vx-col w-full mt-3">
                <p> <feather-icon
                icon='BellIcon'
                svgClasses="w-5 h-5 m-1"
                class="" /> <span class="ml-2"> 30 Minutos antes</span></p>
              </div>
        </div>
      </div>
      <modal
        name="deleteEventModal"
        height="auto"
        width="400"
        :draggable="true"
      >
        <div class="mt-5 mr-3 mb-5">
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col class="" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-chip color="danger" v-if="currEvent.extendedProps">
                <vs-avatar icon="delete" />
                ¿Estas seguro que deseas borrar 
                {{
                  currEvent.extendedProps.type == 'consultation'  ? `la consulta #${currEvent.extendedProps.id}`                  :
                  currEvent.extendedProps.type == 'virtual_consultation' ? `la consulta virtual #${currEvent.extendedProps.id}`   :
                  currEvent.extendedProps.type == 'meeting' ? `el evento #${currEvent.extendedProps.id}`                          :
                  currEvent.extendedProps.type == 'appointment' ? `el recordatorio #${currEvent.extendedProps.id}`                :
                    `el evento #${currEvent.extendedProps.id}`
                }} ?
              </vs-chip>
            </vs-col>
          </vs-row>
          <vs-row class="mt-5" vs-type="flex" vs-justify="flex-end">
            <vs-col class="" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button color="danger" class="mr-3" type="filled" @click="executeDeleteEvent(currEvent.id)">Eliminar</vs-button>
                <vs-button color="success" type="filled" @click="cancelDeleteModal">Cancelar</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </modal>

      <modal
        name="editEventModal"
        height="auto"
        width="400"
        :draggable="true"
      >
        <div class="mt-2 mr-3 mb-5">
          <p>hola mundo edit</p>
        </div>
      </modal>

    </modal>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

import vSelect from 'vue-select'
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
require('vue-simple-calendar/static/css/default.css')
// v-calendar
import Calendar from 'v-calendar/lib/components/calendar.umd'
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import moment from 'moment'
// full calendar
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';

import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/src/locale'

// BUS
import { bus } from '@/main'

// For custom error message
import { Validator } from 'vee-validate'

// country state picker functions
import * as CSP from 'country-state-picker';


// modules
// import moduleClinic from '@/store/clinic/moduleClinic.js'
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
// import moduleEvent from '@/store/event/moduleEvent.js'

const dict = {
  custom: {
    
  }
}

// register custom messages
Validator.localize('es', dict)

export default {
  data () {
    return {
      selected: false,
      patientFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.first_name.toLowerCase().indexOf(temp) > -1 || 
      option.last_name.toLowerCase().indexOf(temp) > -1 ||
      option.email.toLowerCase().indexOf(temp) > -1 
      },
      duration: 60,
      currClinic: {},
      isSecretary: false,
      activeDoctorData: {},
      backupDuration: 0,
      edittingEvent: false,
      edittingId: null,
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
      eventData: {
        eventType: 'consulta',
        title: null,
        notes: null,
        duration: null,
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: "",
        end: ""
      },
      eventDataDef: {
        eventType: 'consulta',
        title: null,
        notes: null,
        duration: null,
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: "",
        end: ""
        
      },
      newClinic: {
        title: null,
        phone: null,
        address: null,
        address2: null,
        zone: null,
        country: null,
        city: null,
        notes: null,
        type: 'Presencial'
      },
      newClinicDef: {
        title: null,
        phone: null,
        address: null,
        address2: null,
        zone: null,
        country: null,
        city: null,
        notes: null,
        type: 'Presencial'
      },
      registerPatient: false,
      notifyPatient: true,
      //
      newPatient: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null
      },
      newPatientDef: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null
      },
      // country options
      countriesList: null,
      clinicsActive: [],
      currClinicsFilter: [],
      typesActive: ["consultation", "meeting", "appointment"],
      currTypesFilter: [],
      currEvent: {},
      eventTypeColors: {
        consulta: '#0033a1',
        virtual: '#28C76F',
        evento: '#33B679',
        recordatorio: '#F4521D',
      },
      newEventErrors: {
        clinic: false,
      },
      calendarConfig: {
        selectedClinics: false,
        clinica1C: false,
        clinica2C: false,
        consultationsC: false,
        meetingsC: false,
        personalC: false,
        otherC: false
      },
      miniCalendar: [
        {
          key: 'Hoy',
          highlight: true,
          dates: new Date(),
        }
      ],
      clinics: null,
      patients: null,
      events: null,
      calendarEvents: [],
      calendarOptions: {
        events: this.calendarEvents,
        eventClick: this.handleEventClick,
        eventBackgroundColor: '#0033a1',
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin ],
        initialView: 'timeGridWeek',
        locales: [ esLocale ],
        nowIndicator: true,
        locale: 'es',
        selectable: true,
        expandRows: true,
        allDayText: 'GTM  ',
        displayEventEnd: false,
        businessHours: [],
        slotLabelFormat: {
          hour: 'numeric',
          omitZeroMinute: false,
          meridiem: 'short',
          hour12: true
        },
        contentHeight: 1100,
        //height: 'auto',
        stickyHeaderDates: true,
        scrollTime: '10:00',
        slotDuration: '01:00',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'customMonth,customWeek,customDay,customAgenda'
        },
        customButtons: {
          customMonth: {
            text: 'Mes',
            click: () => this.setMonthView()
          },
          customWeek: {
            text: 'Semana',
            click: () => this.setWeekView()
          },
          customDay: {
            text: 'Día',
            click: () => this.setDayView()
          },
          customAgenda: {
            text: 'Agenda',
            click: () => this.setAgendaView()
          },
          
        },
        titleFormat: {
          year: 'numeric', month: 'long'
        },
        views: {
          dayGrid: {
            // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
            dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true, columnFormat: 'ddd D' }

          },
          timeGrid: {
            // options apply to timeGridWeek and timeGridDay views
            dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true }

          },
          week: {
            // options apply to dayGridWeek and timeGridWeek views
            dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true, columnFormat: 'ddd D' }
          },
          day: {
            // options apply to dayGridDay and timeGridDay views
            dayHeaderFormat: { weekday: 'long', day: 'numeric' }
          }
        },
        select: this.handleDateSelect,
      },
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'm-d-Y',
        altInput: true,
        altFormat: 'd M Y',
        // defaultDate: new Date(),
        minDate: new Date(),
        locale: ES
      },
      userData: {
      },
      // ---
      isNavOpen: false,
      clinicModal: false,
      wasSidebarOpen: null,
      showDate: new Date(),
      disabledFrom: false,
      // ---
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      langEs: es,
      langEn: en,
      url: '',
      calendarView: 'month',
      activePromptAddEvent: false,
      activeAddPatient: false,
      activePromptEditEvent: false,
    }
  },
  computed: {
    availability (){
      return this.$store.state.schedule
    },
    clinicAvailabilityByDate (){
      return this.$store.state.clinicAvailabilityByDate
    },
    clinicAvailabilityByDateEnd (){
      var end = this.$store.state.clinicAvailabilityByDate.slice(this.$store.state.clinicAvailabilityByDate.findIndex(x => x.date1.includes(this.eventData.hour)))
      return end
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeDoctorData2 () {
      //console.log('DOCTOR ACTIVO!: ',this.$store.state.activeDoctor);
      return this.$store.state.activeDoctor
    },
    activeUserSchedule () {
      return this.$store.state.currentSchedule
    },
    docClinics () {
      let currentClinics = this.$store.state.clinics;
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinics();

      if (zoomClinics.length > 0){
        return currentClinics;
      } else {
        // si no ha activado 
        let defaultVirtual = new Object();
        defaultVirtual.title = 'Clinica Virtual Zoom',
        defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        return [defaultVirtual, ...currentClinics];
      }
    },
    patientsList (){
      return this.$store.state.patients
    },
    eventsList (){
      return this.$store.state.events;
    },
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
          
          && (obj.meta.zoom_active && obj.meta.zoom_active.toLowerCase() == 'true');

      });
      //console.log(zoomClinics);
      return zoomClinics
    },
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.newClinic.country.code);
    },
    getStatesP(){
      return CSP.getStates(this.newPatient.country.code);
    },
    validForm () {
      return this.title !== '' && this.startDate !== ''
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.calendar.eventLabels
    },
    calendarClinics () {
      console.log(this.$store.state);
      return this.$store.state.clinics
    },
    labelColor () {
      return (label) => {
        if      (label === 'business') return 'success'
        else if (label === 'work')     return 'warning'
        else if (label === 'personal') return 'danger'
        else if (label === 'none')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    navbarTypeLocal: {
      get ()    { return this.navbarType },
      set (val) { this.$emit('updateNavbar', val) }
    },
    footerTypeLocal: {
      get ()    { return this.footerType },
      set (val) { this.$emit('updateFooter', val) }
    },
  },
  methods: {
    // date functions
    convertUTC_TIME(dateSTR){
      var d = new Date(dateSTR);
      var time = d.getHours();
      return ("00" + time).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + `${time > 12 ? "PM": "AM"}`
    },
    // clipboard functions
    goLink(link){
      window.open(link, '_blank');
    },
    onCopy: function (e) {
        this.showAlert('success','Link Copiado a Portapapeles', e.text);
    },
    onError: function (e) {
        alert('Failed to copy the text to the clipboard')
        this.showAlert('danger','Error copianto link al portapapeles', e);
    },
    cleanEventData(){
      this.eventData.clinic_id = null,
      this.eventData.patient_id = null
      this.eventData.eventType = null,
      this.eventData.title = null,
      this.eventData.notes = null,
      this.eventData.duration = !this.isSecretary ? 
        this.eventData.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60 : 
        this.eventData.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60,
      this.eventData.notification = true,
      this.eventData.date = null,
      this.eventData.timeType = 'normal',
      this.eventData.clinic_id = null,
      this.eventData.patient_id = null,
      this.eventData.doctor_id = null,
      this.eventData.zoom_email = null,
      this.eventData.zoom_jwt = null,
      this.eventData.clinicType = null;
      this.eventData.end = null;
    },
    buildClinicsFilter (){
      var tempCurrClinicsFilter = [];
      Object.entries(this.clinicsActive).forEach(([key, value], index) => {
        // console.log(key, value);
        if(value){
          // if clinic id is desired add to filter
          tempCurrClinicsFilter.push(parseInt(key));
        }
        if(index == Object.keys(this.clinicsActive).length-1){
          this.currClinicsFilter = tempCurrClinicsFilter;
          // console.log('curClinicsFilter: ',this.currClinicsFilter);
          this.filterEvents();
        }
      });
    },
    openPatientRecord (id) {
      let route = this.$router.resolve({path: `/patients/patient/view/${id}`});
      window.open(route.href, '_blank');
    },
    getWeekDays() {
      if(this.activeUserInfo) {
        if(this.activeUserInfo.role == "doctor"){
           if(this.activeUserInfo.meta && this.activeUserInfo.meta.weekDays) {
            const weekDays = this.activeUserInfo.meta.weekDays;
            return Array.isArray(weekDays) ? weekDays : null
          }
        } else {
          if(this.activeDoctorData.meta && this.activeDoctorData.meta.weekDays) {
            const weekDays = this.activeDoctorData.meta.weekDays;
            return Array.isArray(weekDays) ? weekDays : null
          }
        }
      }
      return [];
    },
    getSchedule(currentDate) {
      let day = moment(currentDate, 'MM-DD-YYYY').day();
      // day = day == 0 ? 7 : day;
      const weekDays = this.getWeekDays();
      return weekDays ? weekDays.find(item => item.id ==day) : null;
    },
    syncBusinessHours() {
      const weekDays = this.getWeekDays();
      if (weekDays) {
        weekDays.forEach(day => {
          if (day.switch) {
            const businessDay = {}
            businessDay.daysOfWeek = [day.id];
            businessDay.startTime = day.switch && day.time ? day.time : null;
            businessDay.endTime = day.switch && day.time2 ? day.time2 : null;
            this.calendarOptions.businessHours.push(businessDay);
          }
        });
      }
    },
    viewUrl(id){
      return '/consultations/newConsultation/?consultationId='+id;
    },
    setCalendarEvents(type){
      //console.log('clinicsActive: ',this.clinicsActive,' CurClinicsFilter: ', this.currClinicsFilter, ' typesActive: ', this.typesActive);

      var fullCalendarRef = this.$refs.fullCalendar.getApi();
      // fullCalendarRef.addEventSource(this.eventsList);
      let convertedEvents = [];
      
      this.eventsList.forEach((element, index, array) => {
        // console.log(filterType,'clinic_id: ', element.clinic_id, Object.values(this.currClinicsFilter), Object.values(this.currClinicsFilter).includes(element.clinic_id));
      //  console.log(element.type);
        // create empty object

        let tempObj = new Object();

        let promise = new Promise((resolve, reject) => {
          if(type == 'filter'){
            if((element.type == "consultation" || element.type == "virtual_consultation") && this.currClinicsFilter.length > 0){
              if(this.currClinicsFilter.includes(element.clinic_id) ){
                
                // console.log(element);
                tempObj.display = 'block';
              
              } else {
                tempObj.display = 'none';
              }
              
            } else if(this.currClinicsFilter.length == 0){
              //console.log(element.type);
              if(this.typesActive.includes(element.type) ){
                tempObj.display = 'block';
              } else {
                tempObj.display = 'none';
              }
            }  else {
              //console.log(element.type);
              if(this.typesActive.includes(element.type) ){
                tempObj.display = 'block';
              } else {
                tempObj.display = 'none';
              }
            }


          } else {
            tempObj.display = 'block';
          }
          
          // insert into empty object 
          tempObj.id = element.id,
          tempObj.title = element.title,
          tempObj.extendedProps = element,
          tempObj.startStr = element.date;

          var sTime1 = new Date(element.date);
          
          tempObj.start = sTime1;
          
          if(element.duration){
            var sTime = new Date(element.date);
            sTime.setMinutes(sTime.getMinutes() + element.duration);
            // console.log(sTime);
            tempObj.end = sTime;
            // tempObj.endStr =  sTime.toISOString;
          }

          if(element.type == 'consultation' && element.clinic) {

            tempObj.backgroundColor = '#0034A1';
            if(element.clinic.meta.type && element.clinic.meta.type.toLowerCase() == 'virtual'){
              tempObj.borderColor = '#29C76F';
            }
          } else if(element.type == 'appointment'){
            tempObj.allDay = true,
            tempObj.backgroundColor = '#00a7e1';
          } else if(element.type == 'meeting'){
            tempObj.backgroundColor = '#021d49';
          }

          setTimeout(() => resolve("done!"), 30);
        });

        promise.then(
          (result) => {
            // insert tempObj into convertedEvents Arr
            convertedEvents[index] = tempObj;
            if(index == array.length-1){
              fullCalendarRef.addEventSource(convertedEvents);
            }
          }
        );
        
        
      });
    },
    filterEvents(){

      var fullCalendarRef = this.$refs.fullCalendar.getApi();
      var eventSources = fullCalendarRef.getEventSources();
      var len = eventSources.length;
      for (var i = 0; i < len; i++) { 
          eventSources[i].remove(); 
      } 
      this.setCalendarEvents('filter');
    },
    findZoomClinics(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )

          && (obj.meta.zoom_active);

      });
      return zoomClinics
    },
    convertEvent(event){
      return new Promise((resolve, reject) => {
        // console.log('EVENT');
        // console.log(even);
        resolve(event);
      });
    },
    // ------------------
    // EVENT ACTIONS
    hideEvent(){
      this.$modal.hide('viewEventModal');
    },
    editEvent(event){
      //console.log(event)
      this.$modal.hide('viewEventModal');
      this.edittingEvent = true,
      this.edittingId = event.extendedProps.id,
      this.eventData.eventType = event.extendedProps.type,
      this.eventData.title = event.extendedProps.title,
      this.eventData.notes = event.extendedProps.notes ? event.extendedProps.notes : '',
      this.eventData.duration = event.extendedProps.duration ? event.extendedProps.duration : 60,
      this.eventData.notification = event.extendedProps.notification,
      // this.eventData.date = event.extendedProps.date,
      this.eventData.timeType = 'normal',
      this.eventData.clinic_id = event.extendedProps.clinic_id ? event.extendedProps.clinic_id : null,
      this.eventData.patient_id = event.extendedProps.patient_id ? event.extendedProps.patient_id : null,
      this.eventData.doctor_id = event.extendedProps.doctor_id,
      this.eventData.zoom_email = null,
      this.eventData.zoom_jwt = null,
      this.eventData.clinicType = null;
      // console.log(this.eventData);
      this.$modal.show('newEventModal');
    },
    cancelEditEvent(){
      this.$modal.hide('newEventModal');
      this.$modal.show('viewEventModal');
    },
    executeEditEvent(){
      // console.log(this.eventData);
      
      let newEventObj = new Object();
      newEventObj.event_id = this.edittingId;
      // event type
      if( this.eventData.eventType == 'consulta' && this.eventData.clinicType == 'presencial') {        

        newEventObj.type = 'consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.eventData.patient_id,
        newEventObj.meta = {"status": "Nueva"},
        newEventObj.duration = parseInt(this.eventData.duration);

      } else if (this.eventData.eventType == 'recordatorio') {
        
        newEventObj.type = 'appointment';
        

      } else if (this.eventData.eventType == 'meeting') {
        newEventObj.type = 'meeting';
        this.backupDuration = this.eventData.duration
        this.eventData.duration = this.duration;
        newEventObj.patient_id = parseInt("25"),
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.duration = parseInt(this.eventData.duration);
        console.log(newEventObj)
        
      }

      newEventObj.title = this.eventData.title,
      newEventObj.notes = this.eventData.notes ? this.eventData.notes : null,
      
      newEventObj.notification = this.eventData.notification;
      
      // newEventObj.doctor_id = this.activeUserInfo.id;

      
      try {
          var d = new Date(this.eventData.date.replace(/-/g, "/"));
      } catch (error) {
          var d = new Date(this.eventData.date);
          console.error(error);
      }
      
      d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
    
      newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
      
      
      this.$store.dispatch('editEvent',newEventObj).then(response => {
            this.eventData = this.eventDataDef;
            
            this.showAlert('success','Evento editado','Evento editado éxitosamente!');
            // console.log(response);
            
            if(true && response.data.data.event.type == "consultation") {
              this.$store.dispatch('sendNotificationEventEditted', response.data.data.event.id).then(response => {
              // console.log(response);
              this.showAlert('success','Paciente Notificado','El paciente fue notificado.');
               }, error => {
              console.error(error);
              }); 
            }
            
            

            // send notification to patient, anouncing that event was modified

            this.$modal.hide('newEventModal');
            // FULLCALENDAR API
            let fullCalendarRef = this.$refs.fullCalendar.getApi();
            // REMOVING EVENT SOURCES 
            var eventSources = fullCalendarRef.getEventSources();
            var len = eventSources.length;
            for (var i = 0; i < len; i++) { 
                eventSources[i].remove(); 
            } 
            //this.filterEvents();
            
            // refetch events and add source again
            this.$store.dispatch('fetchEvents').then(response => {
              console.log('FETCHED');
              //console.log(response);
              // console.log(this.eventsList);
              //this.filterEvents();
              this.setCalendarEvents('');
            }, error => {
              console.error(error);
            }); 
            // fullCalendarRef.addEvent(tempObj);   

        }, error => {
            console.error(error);
            this.showAlert('danger','Error al editar consulta',error.response.data.error);
        });
    },
    deleteEvent(id){
      this.$modal.show('deleteEventModal');
    },
    emailEvent(email){
      window.location.href = "mailto:"+email;
    },
    executeDeleteEvent(id){
      
      this.$store.dispatch('deleteEvent',id).then(response => {
            // console.log(response);
            
            // event sources
            let fullCalendarRef = this.$refs.fullCalendar.getApi();
            var eventSources = fullCalendarRef.getEventSources();
            var len = eventSources.length;
            for (var i = 0; i < len; i++) { 
                eventSources[i].remove(); 
            } 
            // refetch events and add source again
            this.$store.dispatch('fetchEvents').then(response => {
              // console.log(response);
              // console.log(this.eventsList);
              this.setCalendarEvents();
            }, error => {
              console.error(error);
            }); 
            // event sources - end
            this.$modal.hide('viewEventModal');
            this.showAlert('success','Evento eliminado','El evento fue eliminado éxitosamente!');
            
        }, error => {
            console.error(error);
            this.showAlert('danger','Error al eliminar evento',error.response.data.error);
        });
    },
    cancelDeleteModal(){
      this.$modal.hide('deleteEventModal');
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '-' + day + '-' + year;
    },
    // EVENT ACTIONS - END
    // --------------------
    addNewClinic(){
      
      // console.log(this.newClinic);
      let newClinicObj = new Object();
      newClinicObj.address = this.newClinic.address,
      newClinicObj.address_2 = this.newClinic.address2,
      newClinicObj.phone = [this.newClinic.phone],
      newClinicObj.city = this.newClinic.city,
      newClinicObj.zone = this.newClinic.zone,
      newClinicObj.country = this.newClinic.country.name,
      newClinicObj.title = this.newClinic.title,
      newClinicObj.notes = this.newClinic.notes,
      newClinicObj.meta = {"type": this.newClinic.type };

      this.$store.dispatch('addClinic',newClinicObj).then(response => {
            // console.log(response);
            this.showAlert('success','Clinica Agregada','Clinica Agregada éxitosamente!');
            this.newClinic = this.newClinicDef;
            this.$modal.hide('newClinicModal');
        }, error => {
            console.error(error);
            this.showAlert('danger','Error al agregar clinica',error.response.data.error);
        });
      
    },
    setMonthView: function(){
      let fullCalendarRef = this.$refs.fullCalendar.getApi();
      fullCalendarRef.changeView('dayGridMonth');
      fullCalendarRef.setOption('height', '100%');
    },
    setWeekView: function(){
      let fullCalendarRef = this.$refs.fullCalendar.getApi();
      fullCalendarRef.changeView('timeGridWeek');
      fullCalendarRef.setOption('height', '170%');
      
    },
    setDayView: function(){
      let fullCalendarRef = this.$refs.fullCalendar.getApi();
      fullCalendarRef.changeView('timeGridDay');
      fullCalendarRef.setOption('height', '100%');
    },
    setAgendaView: function(){
      let fullCalendarRef = this.$refs.fullCalendar.getApi();
      fullCalendarRef.changeView('listWeek');
      fullCalendarRef.setOption('height', '100%');
    },
    handleEventClick: function(arg) {
      this.currEvent = arg.event;
      this.$modal.show('viewEventModal');
    },
    handleDateSelect: function(arg) {
      this.edittingEvent = false,
      this.edittingId = null,
      this.eventData = this.eventDataDef;
      this.promptAddNewEvent();
    },
    goSettings(){
      window.open('/profile/settings/?activeTab=connections', '_blank');
    },
    // validation
    validateAddNewEvent(type) {
        return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-event').then(result => {
          if (result) {
            if(type == 'add'){
              this.addNewEvent();
            } else if (type == 'edit') {
              this.executeEditEvent();
            }
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    timeDiff (time1, time2) {
      var diff =(time2.getTime() - time1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    addNewEvent () {
      //console.log(this.eventData);
      
      let newEventObj = new Object();
      // event type
      if( this.eventData.eventType == 'consulta') {
        
        if( this.currClinic.meta.type.toLowerCase() == 'presencial' ) {
          newEventObj.type = 'consultation',
          newEventObj.clinic_id = this.eventData.clinic_id,
          newEventObj.patient_id = this.eventData.patient_id,
          newEventObj.meta = {"status": "Nueva"},
          newEventObj.duration = parseInt(this.eventData.duration);
        } else if(this.currClinic.meta.type.toLowerCase()  == 'virtual') {
          let zoomJTW = this.activeUserInfo.role == "doctor" ? this.activeUserInfo.meta.zoom_jwt : this.activeDoctorData.zoom_jwt;
          let zoomEmail = this.activeUserInfo.role == "doctor" ? this.activeUserInfo.meta.zoom_email : this.activeDoctorData.zoom_email;
          //console.log('es virtual')
          newEventObj.zoom_jwt = zoomJTW,
          newEventObj.zoom_email = zoomEmail,
          // 
          newEventObj.type = 'virtual_consultation',
          newEventObj.clinic_id = this.eventData.clinic_id,
          newEventObj.patient_id = this.eventData.patient_id,
          newEventObj.meta = {"status": "Nueva"},
          newEventObj.duration = parseInt(this.eventData.duration);
        }


      } else if (this.eventData.eventType == 'recordatorio') {
        
        newEventObj.type = 'appointment';
        

      } else if (this.eventData.eventType == 'evento') {
        var date1;
        var date2;
        newEventObj.type = 'meeting';
        this.backupDuration = this.eventData.duration
        this.eventData.duration = this.duration;
        newEventObj.patient_id = parseInt("25"),
        newEventObj.clinic_id = this.eventData.clinic_id,
        date1 = this.eventData.date.slice(6,10) +"-"+ this.eventData.date.slice(0,2)+"-"+this.eventData.date.slice(3,5) + "T" + (parseInt(this.eventData.hour.slice(0,2))-3).toString() + ":00"
        date2 = this.eventData.date.slice(6,10) +"-"+ this.eventData.date.slice(0,2)+"-"+this.eventData.date.slice(3,5) + "T" + (parseInt(this.eventData.end.slice(0,2))-3).toString() + ":00"
        newEventObj.duration = parseInt(this.timeDiff(new Date(date1), new Date(date2)));
        console.log(newEventObj.  duration)
        
        console.log(newEventObj)
        
      }

      newEventObj.title = this.eventData.title,
      newEventObj.notes = this.eventData.notes ? this.eventData.notes : null,
      
      newEventObj.notification = this.eventData.notification,
      
      newEventObj.doctor_id = this.activeUserInfo.role == "doctor" ?  this.activeUserInfo.id : sessionStorage.getItem('activeDoctorId');
      
      if(this.eventData.eventType !== 'recordatorio'){
        var d = new Date(this.eventData.date.replace(/-/g, "/"));
        d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
    
        newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
      } else {
        var d = new Date(this.eventData.date.replace(/-/g, "/"));
        // newEventObj.date = tempDate.toISOString();
        newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
      }
      
      
      console.log(newEventObj);
      if (newEventObj.type == 'consultation') {
        this.$store.dispatch('addEvent',newEventObj).then(response => {
              // post addEvent actions
              this.cleanEventData();

              this.eventData.date = null,
              this.eventData.hour = null;
              this.eventData.end = null;
              console.log(this.eventData.end)
              this.clinicAvailabilityByDateEnd = null;
              //console.log(response);
              this.showAlert('success','Consulta Agregada','Consulta Agregada éxitosamente!');
              this.$modal.hide('newEventModal');

              // FULLCALENDAR API
              let fullCalendarRef = this.$refs.fullCalendar.getApi();
              // REMOVING EVENT SOURCES 
              var eventSources = fullCalendarRef.getEventSources();
              var len = eventSources.length;
              for (var i = 0; i < len; i++) { 
                  eventSources[i].remove(); 
              } 
              // refetch events and add source again
              this.$store.dispatch('fetchEvents').then(response => {
                //console.log(response);
                //console.log(this.eventsList);
                this.setCalendarEvents();
              }, error => {
                console.error(error);
              }); 
              // fullCalendarRef.addEvent(tempObj);   

          }, error => {
              console.error(error);
              if(isVirtual && error.response.data.error == 'Request failed with status code 401'){
                this.showAlert('danger','Error en credenciales de Zoom', 'Es posible que las credenciales de zoom están mal, verifica en: <br> ajustes->ajustes->conexiones', 6);
              } else {
                this.showAlert('danger','Error al agregar consulta',error.response.data.error);
              }
          }); 
        } else {
          this.$store.dispatch('addEventType',newEventObj).then(response => {
              // post addEvent actions
              this.cleanEventData();

              this.eventData.date = null,
              this.eventData.hour = null;
              this.eventData.duration = this.backupDuration;
              //console.log(response);
              this.showAlert('success','Consulta Agregada','Consulta Agregada éxitosamente!');
              this.$modal.hide('newEventModal');

              // FULLCALENDAR API
              let fullCalendarRef = this.$refs.fullCalendar.getApi();
              // REMOVING EVENT SOURCES 
              var eventSources = fullCalendarRef.getEventSources();
              var len = eventSources.length;
              for (var i = 0; i < len; i++) { 
                  eventSources[i].remove(); 
              } 
              // refetch events and add source again
              this.$store.dispatch('fetchEvents').then(response => {
                //console.log(response);
                //console.log(this.eventsList);
                this.setCalendarEvents();
              }, error => {
                console.error(error);
              }); 
              // fullCalendarRef.addEvent(tempObj);   

          }, error => {
              console.error(error);
              if(isVirtual && error.response.data.error == 'Request failed with status code 401'){
                this.showAlert('danger','Error en credenciales de Zoom', 'Es posible que las credenciales de zoom están mal, verifica en: <br> ajustes->ajustes->conexiones', 6);
              } else {
                this.showAlert('danger','Error al agregar consulta',error.response.data.error);
              }
          });
        }
    },
    buildEvents(caller){
      
      this.calendarEvents = [];

      this.events.forEach((event, index) => {
        let fullCalendarRef = this.$refs.fullCalendar.getApi();

        //console.log(event);
        let curEvent = new Object();
        curEvent.id = index+1;
        curEvent.start = event.date1;
        curEvent.end = event.date2;
        //curEvent.startTime = event.time1;
        //curEvent.endTime = event.time2;
        curEvent.title = event.title;
        curEvent.notes = event.notes;
        curEvent.time1Str = event.time1;
        curEvent.time1Str = event.time1;
        curEvent.backgroundColor = event.color;
        console.log(event.time1, event.time2, "PUTO")
        this.calendarEvents.push(curEvent);

        if(caller == 'mount'){      
          fullCalendarRef.addEvent(curEvent);
        } 

        if ((caller == 'newEvent') && (this.events.length-1 == index)) {
          fullCalendarRef.addEvent(curEvent);
        }

        
      });
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = '';
      this.id = 0;
      this.labelLocal = 'none';
    },
    handleEventAdd(date){
      this.eventData = this.eventDataDef;
      this.edittingEvent = false,
      this.edittingId = null;
      this.eventData.timeType = 'normal';
      this.promptAddNewEvent(date);
    },
    promptAddNewEvent (date) {
      this.disabledFrom = false;
      this.addNewEventDialog(date);
    },
    addNewPatientDialog () {
      this.activeAddPatient = true
    },
    addNewEventDialog (date) {
      this.clearFields()
      this.startDate = date
      this.endDate = date
      this.$modal.show('newEventModal');
    },
    openAddNewEvent (date) {
      this.disabledFrom = true
      this.addNewEventDialog(date)
    },
    openEditEvent (event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true
    },
    removeEvent () {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged (event, date) {
      this.$store.dispatch('calendar/eventDragged', {event, date})
    },
    // validations
    validateNewClinic(){
      //console.log(this.newClinic);
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-clinic').then(result => {
          if (result) {
            this.addNewClinic();
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateNewPatient(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-patient').then(result => {
          if (result) {
            this.addNewPatient();
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateNewEvent(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-event').then(result => {
          if (result) {
            this.addNewEvent();
            this.$modal.hide('newEventModal');
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    // ADD PATIENT
    addNewPatient(){
      
      //console.log(this.newPatient);
      let newPatientObj = new Object();

      let test = false;

      newPatientObj.address = this.newPatient.address,
      this.newPatient.first_name ? newPatientObj.first_name = this.newPatient.first_name : null,
      this.newPatient.last_name ? newPatientObj.last_name = this.newPatient.last_name : null,
      
      this.newPatient.dob ? newPatientObj.dob = this.newPatient.dob : null,
      this.newPatient.gender ? newPatientObj.gender = this.newPatient.gender : null,
      this.newPatient.phone ? newPatientObj.phone = this.newPatient.phone : null,
      this.newPatient.notification_prefs ? newPatientObj.notification_prefs = this.newPatient.notification_prefs : null,
      this.newPatient.address ? newPatientObj.address = this.newPatient.address : null,
      this.newPatient.address_2 ? newPatientObj.address_2 = this.newPatient.address_2 : null,
      this.newPatient.zone ? newPatientObj.zone = this.newPatient.zone : null,
      this.newPatient.city ? newPatientObj.city = this.newPatient.city : null,
      this.newPatient.country ? newPatientObj.country = this.newPatient.country.name : null,
      this.newPatient.role ? newPatientObj.role = this.newPatient.role : null;
      this.newPatient.email ? newPatientObj.email = this.newPatient.email : newPatientObj.email = 'paciente+' + newPatientObj.phone[0] + '@evolugy.com';

      
      newPatientObj.active = false;

      this.newPatient.idType && this.newPatient.idNum ? 
        this.newPatient.sub_specialty = this.newPatient.idType+' | '+this.newPatient.idNum : null;
      newPatientObj.phone[0] = '502' + this.newPatient.phone[0]
      this.$store.dispatch('addPatient', newPatientObj ).then(response => {
            console.log(response, newPatientObj);

            this.newPatient.first_name = null, this.newPatient.last_name = null,  this.newPatient.email = null,
            this.newPatient.phone[0] = null, this.newPatient.phone[1] = null;

            this.eventData.patient_id = response.data.data.user.id;
            this.eventData.title =  'Cita con '+response.data.data.user.first_name+' '+response.data.data.user.last_name;
            
            this.showAlert('success','Paciente Agregado','Paciente con ID#'+response.data.data.user.id+' Agregado éxitosamente!');
            this.newPatient = this.newPatientDef;
            

            var notifPayload = {
              doctor_name : this.activeUserInfo.role == "doctor" ? this.activeUserInfo.first_name+' '+this.activeUserInfo.last_name 
                : this.activeDoctorData.first_name+' '+this.activeDoctorData.last_name,
              patient_id: response.data.data.user.id,
              patient_name: response.data.data.user.first_name+' '+response.data.data.user.last_name,
              doctor_id: this.activeUserInfo.role == "doctor" ?  this.activeUserInfo.id : sessionStorage.getItem('activeDoctorId'),
              email: response.data.data.user.email,
              phone: response.data.data.user.phone
            } 
            // this.$store.dispatch('sendNotificationNewPatient', notifPayload);
            
            this.$modal.hide('newPatientModal');
            
        }, error => {
            console.error(error.response);
            if(error.response.data.error == 'The email address is already in use by another account.') {
                
                //console.log('...ya existe....');

                this.$modal.hide('newPatientModal');
                
                this.$store.dispatch('fetchAllUsers').then(userResponse => {
                  //console.log(userResponse);
                  const matchUser = userResponse.data.data.users.find(user => user.email === newPatientObj.email);

                  if(matchUser && matchUser.role === 'patient') {
                    const linkPayload = { email: newPatientObj.email, doctor_id: this.isSecretary ? sessionStorage.getItem('activeDoctorId') : this.activeUserInfo.id };

                      this.$store.dispatch('linkUser', linkPayload).then( (response) =>{
                          this.showAlert('success','Paciente Vinculado Exitosamente!',
                            'Paciente: '+matchUser.first_name + ' '+ matchUser.last_name+'  Correo: '+matchUser.email );

                      }, error => {
                        if(error.response.data.error == 'The users were linked previously') {
                          this.showAlert('danger','Este paciente ya fue vinculado.',error.response.data.error);
                        } else {
                          console.error(error);
                        }
                        
                      });
                  } else {
                    this.showAlert('danger','No es posible vincular este usuario porque no es un paciente.',error.response.data.error);
                  }
                });
              }
              else {
                this.showAlert('danger','Error al agregar paciente.',error.response.data.error);
              }
        });
      
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    }
  },
  components: {
    vSelect,
    flatPickr,
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    Calendar,
    FullCalendar
  },
  beforeMount (){
    if(this.activeUserInfo.role == "secretary" ){
        this.isSecretary = true;
        this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
          //console.log('DOCTOR: ',response);
          this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
          this.eventData.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60 ;
          this.eventDataDef.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60;
        }, error => {
          console.error(error);
        });
      } else {
        this.isSecretary = false;
        this.eventData.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60;
        this.eventDataDef.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60;
      }
  },
  mounted () {

    
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true);
    this.navbarTypeLocal = 'hidden';
    this.footerTypeLocal = 'hidden';    
   
  },
  beforeCreate (){

    this.countriesList = CSP.getCountries();
  },
  created () {
    
      // sync User Availability to calendar
      this.syncBusinessHours();

      this.$store.dispatch('fetchClinics').then(response=>{
        this.eventData.clinic_id = this.$store.state.clinics[0].id
        this.$store.state.clinics.forEach((clinic, index, arr) => {
          this.clinicsActive[clinic.id] = true;
        });
      }, error => {
        console.error(error);
      });
      this.$store.dispatch('fetchPatients');
      this.$store.dispatch('fetchEvents').then(response => {
        
          // console.log(response);
          // console.log(this.eventsList);
          this.setCalendarEvents();

          // SCHEDULE TIMETABLE
          var schedulePayload = new Object();
          schedulePayload.date = this.getFormattedDate(new Date());


          // this.$store.dispatch('buildSchedule', schedulePayload).then(response => {
          //   // console.log(response);
          // }, error => {
          //     console.error(error);
          // }); 
          // // SCHEDULE TIMETABLE

      }, error => {
          console.error(error);
      }); 


    bus.$on('VNavReduced', (data) => {
      let fullCalendarRef = this.$refs.fullCalendar.getApi();
      // console.log('VNavReduced: '+data);
      
      setTimeout(() => {
        fullCalendarRef.updateSize();
      }, 500);
    });
    
  },
  beforeDestroy () {
    
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    this.navbarTypeLocal = 'floating';
    this.footerTypeLocal = 'sticky';
  },
  // watchers
  watch: {
    eventsList(newVal, oldVal){
    },
    calendarEvents: function (newVal,oldVal) {
      // console.log('CalendarEvents changed');
      // console.log(newVal);
    },
    'eventData.patient_id': function(newVal, oldVal) {
      if(this.eventData.patient_id){
        var patient = this.patientsList.filter(obj => {
          return obj.id === this.eventData.patient_id
        });
        // console.log(patient);
        this.eventData.title = 'Cita con '+patient[0].first_name+' '+patient[0].last_name;
      }  else {
        this.eventData.title = '';
      }   
    },
    'eventData.date': function(newVal, oldVal) {
      // creating request payload
      console.log('cambio date: N: ',newVal, 'O: ',oldVal);
      try {
          var DateSelected = new Date(newVal.replace(/-/g, "/"));
          var DateAfter = new Date(DateSelected);
          if (this.eventData.clinic_id==null) {
            this.eventData.clinic_id = this.$store.state.clinics[0].id
          } 
      } catch (error) {
          var DateSelected = new Date(newVal);
          var DateAfter = new Date(DateSelected);
          console.error(error);
      }
      // console.log(DateSelected,DateAfter);
      
      DateAfter.setDate(DateAfter.getDate()+1);
      this.eventData.hour = null;
      // console.log(DateSelected,DateAfter);
      
      // -------- fetching clinic schedule by date --------
      var fetchClinicSchedule_payload = new Object();
      fetchClinicSchedule_payload.clinic_id = this.eventData.clinic_id,

      fetchClinicSchedule_payload.start_date = DateSelected.toISOString().split('T')[0]+'T06:00',
      fetchClinicSchedule_payload.end_date = DateAfter.toISOString().split('T')[0]+'T05:59',
      fetchClinicSchedule_payload.requestDate = new Date().toISOString().substring(0,16),
      fetchClinicSchedule_payload.eventLength = this.eventData.duration;
      console.log(fetchClinicSchedule_payload)

      if(this.eventData.clinic_id && this.eventData.duration){
        this.$store.dispatch('fetchClinicSchedule', fetchClinicSchedule_payload).then(response => {
          console.log('RESPONSE: ',response);
        }, error => {
            console.error(error);
        }); 
      }
    },
    'eventData.clinic_id': function(newVal, oldVal) {
      console.log(`Cabmio clinica: new:${newVal} old:${oldVal}`);
      this.eventData.date = null;
      let currClinic = this.$store.state.clinics.filter(obj => {
        return ( obj.id  ==  newVal )
      });
      this.currClinic =  currClinic[0];
      console.log(this.currClinic)
    },
    clinicsActive: function(newVal){
      // console.log('clinicsActive: ',this.clinicsActive);
      this.buildClinicsFilter();
    },
    typesActive:
    
      function(newVal){
      
        console.log(this.typesActive);
        if(!this.typesActive.includes("consultation")){
          this.clinicsActive.forEach((element, indx, arr) => {
            this.clinicsActive[indx] = false; 
          });
        } else {
          this.clinicsActive.forEach((element, indx, arr) => {
            this.clinicsActive[indx] = true;
          });
        }
        setTimeout(() => {
          this.buildClinicsFilter();
        }, 300);
    },
    immediate: true
  }
}

</script>


<style>
.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
    height: 25px;
    position: static;
    top: -17px;
    z-index: 999;
    background-color: white;
    padding-top: 25px;
    padding-bottom: 25px;
}

.vc-container{
  border-width: 0px !important;
}

.fc-col-header-cell-cushion {
    padding: 2px 4px;
    text-transform: uppercase;
}

.fc .fc-toolbar-title {
    text-transform: capitalize;
}

button.fc-button.fc-button-primary{
  background-color: #0033a1 !important;
}
.overflow {
    overflow:visible;
  }
  .style-chooser .vs__dropdown-menu {
    max-height: 200px;
  }

/* .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
    position: absolute;
    BACKGROUND-COLOR: WHITE;
    Z-INDEX: 999;
    top: 0px;
    width: 70vw;
    height: 50px;
    padding-right: 10px;
}

.fc-view-harness.fc-view-harness-active {
    margin-top: 40px;
}

.router-view {
    padding: 0.5rem !important;
} */
</style>
